import { render, staticRenderFns } from "./WorkspaceExpandIntentAdd.vue?vue&type=template&id=6c11dce9&scoped=true"
import script from "./WorkspaceExpandIntentAdd.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandIntentAdd.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandIntentAdd.vue?vue&type=style&index=0&id=6c11dce9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11dce9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c11dce9')) {
      api.createRecord('6c11dce9', component.options)
    } else {
      api.reload('6c11dce9', component.options)
    }
    module.hot.accept("./WorkspaceExpandIntentAdd.vue?vue&type=template&id=6c11dce9&scoped=true", function () {
      api.rerender('6c11dce9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandIntentAdd.vue"
export default component.exports